import { render, staticRenderFns } from "./vchannel.vue?vue&type=template&id=0bbc0e5f&"
import script from "./vchannel.vue?vue&type=script&lang=js&"
export * from "./vchannel.vue?vue&type=script&lang=js&"
import style0 from "./vchannel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports